// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"5fee0622","292":"0af86c5e","369":"0b318118","513":"6d24a0af","601":"9e194f9f","703":"0e344c07","921":"37ce1c64"}[chunkId] + ".chunk.js";
};